export const ORDERS_GET_REQUEST = "@orders.get.request";
export const ORDERS_GET_SUCCESS = "@orders.get.success";
export const ORDERS_GET_FAIL = "@orders.get.failure";

export const ORDER_LOAD_REQUEST = "@orders.load.request";
export const ORDER_LOAD_SUCCESS = "@orders.load.success";
export const ORDER_LOAD_FAIL = "@orders.load.failure";

export const ORDER_CREATE_REQUEST = "@orders.create.request";
export const ORDER_CREATE_SUCCESS = "@orders.create.success";
export const ORDER_CREATE_FAIL = "@orders.create.failure";
export const ORDER_CREATE_DONE = "@orders.create.done";

export const ORDER_UPDATE_REQUEST = "@orders.update.request";
export const ORDER_UPDATE_SUCCESS = "@orders.update.success";
export const ORDER_UPDATE_FAIL = "@orders.update.failure";
export const ORDER_UPDATE_DONE = "@orders.update.done";

// Used by ActiveItem trait
export const ACTIVE_REQUEST = "@orders.active.request";
export const ACTIVE_CLEAN = "@orders.active.clean";
export const ACTIVE_SUCCESS = "@orders.active.success";
export const ACTIVE_FAIL = "@orders.active.fail";
